/* eslint-disable */
import React, { useCallback, useState, useRef, useEffect } from 'react';
import './index.scss';
import useHistory from 'src/hooks/useHistory';
import useSort from 'src/hooks/useSort';
import useTheme from 'src/hooks/useTheme';
import { useMarket } from 'src/context/marketContext';

const GameSort = () => {
  const { theme } = useTheme();
  const { ui } = useMarket();
  const options = {
    popular: { code: 'popular', title: ui.sortPopular },
    new: { code: 'new', title: ui.sortNew },
    maxWin: { code: 'maxWin', title: ui.sortMaxWin },
    rtp: { code: 'rtp', title: ui.sortRtp },
  };
  const { updateSearchParams } = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const {
    sortBy,
    sortDirection,
    setSortBy,
    setSortDirection,
    sortByKey,
    sortDirectionKey,
  } = useSort();

  const onSortByChange = useCallback(
    (code) => {
      updateSearchParams(sortByKey, code);
      setSortBy(code);
      setIsOpen(false);
    },
    [updateSearchParams, sortByKey, setSortBy],
  );

  const onSortDirectionChange = useCallback(() => {
    const direction = sortDirection === 'asc' ? 'desc' : 'asc';
    updateSearchParams(sortDirectionKey, direction);
    setSortDirection(direction);
  }, [sortDirection, sortDirectionKey, updateSearchParams, setSortDirection]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="sort-controls" ref={dropdownRef}>
      <div className="sort-dropdown">
        <button
          className="sort-trigger"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="sort-label">{ui.sortLabel}</span>
          <span className="sort-value">{options[sortBy]?.title}</span>
          <svg className={`sort-chevron ${isOpen ? 'open' : ''}`} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>

        {isOpen && (
          <div className="sort-menu">
            {Object.values(options).map((x) => (
              <button
                key={x.code}
                className={`sort-option ${x.code === sortBy ? 'active' : ''}`}
                onClick={() => onSortByChange(x.code)}
              >
                <span>{x.title}</span>
                {x.code === sortBy && (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                )}
              </button>
            ))}
          </div>
        )}
      </div>

      <button
        className="sort-direction"
        onClick={onSortDirectionChange}
        aria-label={sortDirection === 'asc' ? 'Sort ascending' : 'Sort descending'}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={sortDirection === 'asc' ? 'flipped' : ''}
        >
          <line x1="12" y1="5" x2="12" y2="19"/>
          <polyline points="19 12 12 19 5 12"/>
        </svg>
      </button>
    </div>
  );
};

export default GameSort;
